import styled from '@emotion/styled';
import { TablePropsType, TableWrapperTemplate, TableHeaderRowTemplate, TableRowTemplate, ColumnHeaderTemplate, TableCellTemplate, SectionMessageTemplate } from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })`
`;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })`
`;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' }) <TablePropsType>`
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })`
    width: 16.66%;
`;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`
    width: 16.66%;
    span {
        display: block;
    }
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })`
`;

export const RowWithTable = styled('td', { label: 'RowWithTable' })`
    padding: 0 !important;
`;

export const InnerTable = styled('table', { label: 'InnerTable' })`
    vertical-align: middle;
`;

export const TableRowAddColor = styled('tr', { label: 'TableRowAddColor' })`
    background: inherit !important; //remove after delete class .fraud-and-compliances-tab
`;
